import { render, staticRenderFns } from "./postCompany.vue?vue&type=template&id=1bf36977&"
import script from "./postCompany.vue?vue&type=script&lang=js&"
export * from "./postCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports